import React from "react";

const ConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg p-6 shadow-lg">
        <h2 className="text-lg font-semibold mb-4">
          Are you sure you want to delete?
        </h2>
        <p>You won't be able to undo this action.</p>
        <div className="flex justify-end mt-4">
          <button
            className="btn min-h-7 h-10 btn-outline mt-1 mr-2 px-6"
            onClick={onClose}
          >
            No
          </button>
          <button
            className="btn min-h-7 h-10 bg-red-500 text-white mt-1 px-5"
            onClick={onConfirm}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
